export default __webpack_public_path__ + "static/media/image_6.7a31970a.jpg";